export default __webpack_public_path__ + "static/media/hh-logo.d553f967.png";